import { lazy, Suspense } from "react"
import { createBrowserRouter } from "react-router-dom"
import App from "../App"
import { HomePage, AboutMePage, ServicesPage } from "../pages"
import { WrongRouteMsg } from "../components"

// Lazy load GalleryPage - only downloads when user navigates to /gallery
const GalleryPage = lazy(() =>
  import("../pages/GalleryPage").then((module) => ({
    default: module.GalleryPage,
  })),
)

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <HomePage />,
        children: [{ path: "#:section", element: <HomePage /> }],
      },
      {
        path: "/about-me",
        element: <AboutMePage />,
      },
      {
        path: "/services",
        element: <ServicesPage />,
      },
      {
        path: "/gallery",
        element: (
          <Suspense fallback={<div className="loading-spinner">Betöltés</div>}>
            <GalleryPage />
          </Suspense>
        ),
      },
      { path: "*", element: <WrongRouteMsg /> },
    ],
  },
])
